import { useQuery } from '@tanstack/react-query'

import { fetchUnreadCount } from './api'

export const UNREAD_COUNT_KEY = ['notifications', 'unread-count'] as const

/** drives the bell badge. real-time updates ride the socket
 * (`notification:*` events update this same query data via setQueryData
 * in socket-handlers.ts). the socket is primary, but it can miss a change
 * the client never hears about (a dropped event, or a server-side bulk
 * edit done outside the app). the global default disables focus refetch
 * and the bell never remounts, so without an explicit trigger such a count
 * stays stale until a full reload. refetch on focus + reconnect makes the
 * 30s stale window a real backstop: the badge re-syncs with the server
 * whenever the user returns to the tab or the socket reconnects.
 * returns the raw UseQueryResult to match useMessagingUnreadCount. the
 * render-side `?? 0` lives in the consumer.
 */
export function useUnreadCount() {
  return useQuery({
    queryKey: UNREAD_COUNT_KEY,
    queryFn: ({ signal }) => fetchUnreadCount(signal),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: false
  })
}
